export enum ProjectstatusEnum {
  STUDIE = 'Studie',
  START = 'Start',
  INITIATIEF = 'Initiatief',
  DEFINITIE = 'Definitie',
  ONTWERP = 'Ontwerp',
  VOORBEREIDING = 'Voorbereiding',
  BOUWVOORBEREIDING = 'Bouwvoorbereiding',
  REALISATIE_TOT_EERSTE_WONING = 'Realisatie tot eerste woning',
  REALISATIE_TOT_LAATSTE_WONING = 'Realisatie tot laatste woning',
  NAZORG = 'Nazorg',
  AFGEROND = 'Afgerond',
  ONBEKEND = 'Onbekend',
}
